import { observable, makeObservable } from 'mobx'
import { CONFIG } from '../config'
import { DeviceWidth, IBreakpoints } from '../interfaces'
import { Breakpoints } from '../enums'
import { debounce } from '../utils'

class BreakpointStore {
  breakpoint: DeviceWidth = this.determineBreakpoints

  constructor() {
    makeObservable(this, {
      breakpoint: observable.struct
    })

    window.onresize = debounce(() => {
      this.breakpoint = this.determineBreakpoints
    }, 100)
  }

  get determineBreakpoints(): DeviceWidth {
    return {
      above: Object.keys(Breakpoints).reduce((prev, curr) => {
        const breakpoint = curr as Breakpoints
        return {
          ...prev,
          [breakpoint]: window.innerWidth >= CONFIG.breakpoints[breakpoint]
        }
      }, {}) as IBreakpoints<boolean>
    }
  }
}
export const breakpointStore = new BreakpointStore()
